export function calculateNewDimensions(
  originalWidth,
  originalHeight,
  newWidth = null,
  newHeight = null
) {
  if (newWidth !== null && newHeight === null) {
    const ratio = originalHeight / originalWidth;
    return {
      width: newWidth,
      height: Math.round(newWidth * ratio),
    };
  }

  if (newHeight !== null && newWidth === null) {
    const ratio = originalWidth / originalHeight;
    return {
      width: Math.round(newHeight * ratio),
      height: newHeight,
    };
  }

  return {
    width: newWidth || originalWidth,
    height: newHeight || originalHeight,
  };
}
